<template>
    <div v-if="loading == false">
        <div class="row m-0 align-items-center bgG2">
            <div class="col-12 col-lg-6 ps-4 ps-md-5 mb-5">
                <h1 class="cG8 ms-md-5 mt-5" style="max-width: 65%;">
                    <a :href="'/builders/' + instrument.builder.id" class="text-decoration-none cG8" target="_blank" v-if="instrument.builder">{{instrument.builder.name }}</a>
                    <span class="text-decoration-none cG8" v-else>{{ instrument.submissionBuilder }}</span>
                    <br />
                    <span v-if="instrument.opus">Opus <span v-if="instrument.opusPrefix">{{ instrument.opusPrefix }}</span>{{ instrument.opus }}<span v-if="instrument.opusSuffix">{{ instrument.opusSuffix }}</span><span v-if="instrument.year">, </span></span>
                    <span v-if="instrument.year"><span v-if="instrument.yearPrefix">{{ instrument.yearPrefix }}</span>{{ instrument.year }}<span v-if="instrument.yearSuffix">{{ instrument.yearSuffix }}</span></span>
                </h1>
                <h4 v-if="instrument.originalBuilder" class="ms-md-5" style="max-width: 60%;"><b>Originally <a :href="'/builders/' + instrument.originalBuilder.id" target="_blank" class="text-decoration-none cG8">{{ instrument.originalBuilder.name }}</a> <span
                                        v-if="instrument.originalOpus || instrument.originalYear">(</span><span
                                        v-if="instrument.originalOpus">Opus <span v-if="instrument.originalOpusPrefix">{{ instrument.originalOpusPrefix }}</span>{{ instrument.originalOpus}}<span v-if="instrument.originalOpusSuffix">{{ instrument.originalOpusSuffix }}</span><span v-if="instrument.originalYear">,
                                        </span></span><span v-if="instrument.originalYear"><span v-if="instrument.originalYearPrefix">{{ instrument.originalYearPrefix }}</span>{{ instrument.originalYear }}<span v-if="instrument.originalYearSuffix">{{ instrument.originalYearSuffix }}</span></span><span
                                        v-if="instrument.originalOpus || instrument.originalYear">)</span></b></h4>
                <a :href="'/locations/'+instrument.location.id" target="_blank" class="text-decoration-none text-dark" v-if="instrument.location"><h3 class="ms-md-5" style="max-width: 55%;">{{ instrument.location.name || "Unidentified Location" }}</h3>
                <h3 class="ms-md-5" v-if="instrument.room"><i>{{ instrument.room }}</i></h3>
                <h4 class="ms-md-5 cR4" v-if="instrument.location">
                    <span v-if="instrument.location.address"><small>{{ instrument.location.address }}</small></span><br v-if="instrument.location.address" />
                    <span v-if="instrument.location.city || instrument.location.neighborhood">{{ instrument.location.city }}<span v-if="instrument.location.neighborhood"> ({{instrument.location.neighborhood}})</span>, </span>
                    <span v-if="instrument.location.state">{{ instrument.location.state }}, </span>
                    {{ instrument.location.country }}
                </h4></a>
                <h3 class="ms-md-5" style="max-width: 55%;" v-else>{{ instrument.submissionLocation }}</h3>
                <h6 class="ms-md-5" v-if="instrument.ranks || instrument.pipes || instrument.divisions">
                    <span v-if="instrument.ranks">{{ instrument.ranks }} Ranks <span v-if="instrument.pipes || instrument.divisions">- </span></span>
                    <span v-if="instrument.pipes">{{ instrument.pipes.toLocaleString() }} Pipes <span v-if="instrument.divisions">- </span></span>
                    <span v-if="instrument.divisions">{{ instrument.divisions }} Physical Divisions</span>
                </h6>
                <h6 class="ms-md-5 text-secondary" style="max-width: 80%;">Instrument ID: {{instrument.id}} <span v-if="instrument.builder">&#9679; Builder ID: {{instrument.builder.id}}</span> <span v-if="instrument.location">&#9679; Location ID: {{instrument.location.id}}</span></h6>
                <small class="text-secondary ms-md-5 d-block" style="max-width: 85%;">⬆️ These are database IDs that may change. Don't use as academic reference.</small>
                <h6 class="cR4 ms-md-5" v-if="instrument.approvalStatus == 0"><i>Pending Review</i></h6>
                <h6 class="cR4 ms-md-5" v-if="instrument.approvalStatus == -1"><i>Denied In Review</i></h6>
                <h5 class="text-success mb-0 ms-md-5" v-if="instrument.hasOHSCitation == true">Historic Organ Citation Awardee</h5>
                <a href="#images" style="border-radius: 0;" class="btn btn-dark ms-md-5 btn-lg mt-4 me-3" v-if="instrument.images && instrument.images.length > 0">EXPLORE IMAGES</a>
                <a href="#stoplists" style="border-radius: 0;" class="btn btn-outline-dark btn-lg mt-4" v-if="instrument.stoplists && instrument.stoplists.length > 0" v-bind:class="{'ms-md-5': instrument.images == null || instrument.images.length == 0}">VIEW STOPLIST</a>
                <div class="d-block ms-md-4"><a href="#details" style="border-radius: 0;" class="btn btn-secondary mt-4 ms-md-5 ps-3 pe-3 pt-2 pb-2">ADDITIONAL INFORMATION</a></div>
                <p class="ms-md-5 mt-5 editText">
                    <i class="me-2">Something not quite correct?</i>
                    <a class="btn btn-sm btn-secondary me-2" :href="editInstrumentLink" target="_blank"><span v-if="!loggedIn">Suggest an Edit</span><span v-else>Edit Instrument</span></a>
                    <i v-if="loggedIn" class="me-2">or</i>
                    <button class="btn btn-sm btn-danger me-2" v-if="loggedIn" @click="deleteInstrument">Delete</button>
                </p>
            </div>
            <div class="col-12 col-md-6 bgImg d-none d-lg-block" v-bind:style="{backgroundImage: 'url(' + apiEndpoint + '/uploads/images/' + headerImage.filename + ')'}"></div>
        </div>
        <div class="container-fluid p-5" style="background-color: #ff8787;" v-if="instrument.originalInstrument || instrument.futureInstrument">
            <div class="row align-items-center">
                <div class="col-12 col-lg-6">
                    <h3>This instrument has multiple revisions:</h3>
                </div>
                <div class="col-12 col-lg-6 text-lg-end">
                    <a :href="'/instruments/' + instrument.originalInstrument.id" class="btn btn-outline-dark text-uppercase mt-3 mt-lg-0 btn-lg" v-if="instrument.originalInstrument" style="border-radius: 0; font-family: 'Oswald', sans-serif; font-weight: 400;">View Older ({{instrument.originalInstrument.year}}) Revision</a>
                    <a :href="'/instruments/' + instrument.futureInstrument.id" class="btn btn-outline-dark text-uppercase btn-lg ms-md-3 mt-3 mt-lg-0" v-if="instrument.futureInstrument" style="border-radius: 0; font-family: 'Oswald', sans-serif; font-weight: 400;">View Newer ({{instrument.futureInstrument.year}}) Revision</a>
                </div>
            </div>
        </div>
        <div class="container-fluid p-5 bg-secondary" v-if="sponsor">
            <div class="row align-items-center justify-content-center">
                <div class="col-12 col-xl-6 col-lg-8 text-center text-light">
                    <h1 style="display: block; position: absolute;"><a href="https://plenumorgans.com/" target="_blank" style="color: rgba(108, 117, 125, 0) !important;">Plenum Organ Company</a></h1>
                    <h2>🤝 Instrument entries in {{ sponsor.state }} sponsored by:</h2> 
                    <p class="lead d-none d-md-block">We are grateful for the generous support of our sponsors, who make it possible for us to continue our mission of preserving and promoting the rich history of pipe organs across the globe.</p>
                </div>
                <div class="col-12 col-lg-4 text-center">
                    <a :href="sponsor.webpage" target="_blank"><img class="img-fluid rounded shadow" :src="apiEndpoint + '/uploads/images/sponsors/' + sponsor.image"/></a>
                </div>
            </div>
        </div>
        <div class="container-fluid p-5 bgG9" id="images">
            <div class="row align-items-center">
                <div class="col-12 col-md-8 col-lg-9 text-light mb-3 mb-md-0">
                    <h2 class="decorativeUnderline">IMAGES</h2>
                </div>
                <div class="col-12 col-md-4 col-lg-3 text-end">
                    <div class="input-group">
                        <span class="input-group-text">Category:</span>
                        <select class="form-select" v-model="imageType">
                            <option value="-1">All</option>
                            <option v-for="(type, i) in imageTypeOptions" :key="i" :value="i" :disabled="imageTypes.indexOf(parseInt(i)) == -1">{{ type }}</option>
                        </select>
                    </div>
                    <div class="form-text text-center text-secondary"><small>Only show images in a specific category ☝️</small></div>
                </div>
            </div>
            <div class="row mt-5">
                <MasonryWall :items="filteredImages" :gap="30" :max-columns="3" :key="filteredImages.length">
                    <template #default="{ item }">
                        <div v-if="item.isPanoramic == 0">
                            <a v-bind:data-fancybox="imageType" v-bind:data-src="apiEndpoint + '/uploads/images/' + item.filename" v-bind:data-caption="item.name + ' | ' + item.source + getImageDate(item)"><img v-bind:src="apiEndpoint + '/uploads/images/' + item.fullThumbFilename" class="img-fluid w-100" /></a>
                        </div>
                        <div v-if="item.isPanoramic == 1">
                            <iframe height="300" allowfullscreen style="border-style: none; width: 100%" v-bind:src="'https://cdn.pannellum.org/2.5/pannellum.htm#panorama=' + apiEndpoint + '/uploads/images/' + item.filename + '&amp;preview=' + apiEndpoint + '/uploads/images/' + item.fullThumbFilename + '&amp;title=' + encodeURI(item.name) + '&amp;author=' + encodeURI(item.source + getImageDate(item))"></iframe>
                        </div>
                        <div class="mt-1" v-if="loggedIn">
                            <a :href="'/images/' + item.id + '/edit'" class="btn btn-sm btn-secondary me-1" target="_blank">Edit</a><button class="btn btn-sm btn-danger me-2" @click="deleteImage(item.id)">Delete</button><span class="cR4" v-if="item.approvalStatus == 0"><i>Pending Review</i></span><span class="cR4" v-if="item.approvalStatus == -1"><i>Denied In Review</i></span>
                        </div>
                    </template>
                </MasonryWall>
                <button v-if="instrument.images.length > 10 && showAllImages == 0 && imageType == -1" class="btn btn-secondary mt-3" @click="showAllImages = 1">Show All</button>
                <div class="col-12 mb-2" v-if="instrument.images.length == 0">
                    <h4 class="text-light">No images are available. If you have pictures of this instrument, please consider sharing them with us.</h4>
                </div>
                <p class="mt-3 text-light text-md-center editText">
                    <i class="me-2">Something missing<span v-if="instrument.images.length > 0"> or not quite correct</span>?</i>
                    <a class="btn btn-sm btn-secondary me-2" :href="'/images/add?instrumentIds='+instrument.id" target="_blank">Add Image</a>
                    <i v-if="instrument.images.length > 0 && !loggedIn" class="me-2">or</i>
                    <a class="btn btn-sm btn-secondary me-2" v-if="instrument.images.length > 0 && !loggedIn" :href="'/editRequests/add?itemCategory=2&itemType=1&itemId='+instrument.id" target="_blank">Suggest an Edit</a>
                </p>
            </div>
        </div>
        <div class="container-fluid p-5" id="stoplists" style="background-color: #f8f9fa;">
            <div class="row align-items-center">
                <div class="col-12 col-md-8 mb-3 mb-md-0">
                    <h2 style="text-decoration: underline; text-decoration-color: #ff8787; text-decoration-thickness: 0.3rem !important; text-underline-offset: 0.1em;">STOPLISTS</h2>
                </div>
                <div class="col-12 col-md-4 text-end" v-if="instrument.stoplists.length > 0">
                    <div class="input-group">
                        <span class="input-group-text">Selected Item:</span>
                        <select class="form-select" v-model="stoplistSelection" @change="calculateStoplist" :disabled="instrument.stoplists.length < 2">
                            <option v-for="(stoplist, i) in instrument.stoplists" :value="i" :key="stoplist.id">
                                {{stoplist.source}}
                            </option>
                        </select>
                    </div>
                    <div class="form-text text-center"><small>View additional stoplist entries if they exist ☝️</small></div>
                </div>
            </div>
            <div class="text-md-center text-secondary" v-if="instrument.stoplists.length > 0 && instrument.stoplists[this.stoplistSelection].type == 0">Click on a stop or division name for additional details.</div>
            <div class="row stoplistView justify-content-center mb-5" v-if="instrument.stoplists.length > 0 && instrument.stoplists[this.stoplistSelection].type == 0">
                <div class="col-12 col-md-6 col-xl-4 mt-5" v-for="division in stoplistDivisions" :key="division.id">
                    <table class="table table-borderless w-auto" style="margin: 0 auto;">
                        <tbody>
                            <tr class="dropdown stopItem">
                                <td class="pb-1 pt-0 text-end" style="width: 15% !important;"></td>
                                <td class="pb-1 pt-0 divisionName" style="width: 60% !important;" data-bs-toggle="dropdown" aria-expanded="false">
                                    <i>
                                        <b class="text-uppercase">{{division.name}}</b><span v-if="division.keyboard || division.isEnclosed == 1"> (</span><span v-if="division.keyboard">{{toRoman(division.keyboard)}}</span><span v-if="division.keyboard && division.isEnclosed == 1"> - </span><span v-if="division.isEnclosed == 1">Expressive</span><span v-if="division.keyboard || division.isEnclosed == 1">)</span>
                                    </i>
                                </td>
                                <ul class="dropdown-menu stoplistDropdown">
                                    <li v-if="division.position"><b>Position</b>: {{divisionPositionTypeOptions[division.position]}}</li>
                                    <li v-if="division.chestActionType"><b>Chest Action</b>: {{divisionChestActionTypeOptions[division.chestActionType]}}</li>
                                    <li v-if="division.stopActionType"><b>Stop Action</b>: {{divisionStopActionTypeOptions[division.stopActionType]}}</li>
                                    <li v-if="division.notes"><b>Notes</b>: {{division.notes}}</li>
                                </ul>
                            </tr>
                            <tr v-for="stop in division.stops" :key="stop.id" class="dropdown stopItem">
                                <td class="pb-1 pt-0 text-end" v-if="stop.length">{{stop.length}}<span v-if="(stop.numRanks && stop.numRanks < 2) || parseInt(stop.length)">'</span></td>
                                <td class="pb-1 pt-0 text-end" v-if="stop.length == null || stop.length == ''"></td>
                                <td class="pb-1 pt-0 stopName" data-bs-toggle="dropdown" aria-expanded="false">
                                    <b :class="{'cR4': stop.isReed == 1}">{{stop.name}}</b>
                                </td>
                                <td class="pb-1 pt-0 pl-5 text-end" v-if="stop.isPrepared == 0 && stop.isDigital == 0">{{stop.pipes}} <i v-if="stop.extendedFrom">{{stop.extendedFrom}}</i></td>
                                <td class="pb-1 pt-0 pl-5 text-end" v-if="stop.isPrepared == 0 && stop.isDigital == 1">DIG <i v-if="stop.extendedFrom">{{stop.extendedFrom}}</i></td>
                                <td class="pb-1 pt-0 pl-5 text-end" v-if="stop.isPrepared == 1">PF</td>
                                <ul class="dropdown-menu stoplistDropdown">
                                    <li v-if="stop.windPressure"><b>Wind Pressure</b>: {{ stop.windPressure }}"</li>
                                    <li v-if="stop.notes"><b>Notes</b>: {{stop.notes}}</li>
                                </ul>
                            </tr>
                            <tr v-if="division.couplers.length > 0" class="stopItem">
                                <td class="pb-2"></td>
                            </tr>
                            <tr v-for="coupler in division.couplers" :key="coupler.id" class="dropdown stopItem">
                                <td class="pb-1 pt-0 text-end"><span v-if="!coupler.altName && !coupler.isUnisonOff == 1">{{coupler.length}}'</span></td>
                                <td class="pb-1 pt-0 stopName" data-bs-toggle="dropdown" aria-expanded="false"><span v-if="coupler.altName">{{ coupler.altName }}</span><span v-else><span v-if="!coupler.isUnisonOff == 1">{{coupler.from}} to </span>{{coupler.to}}<span v-if="coupler.isUnisonOff == 1"> Unison Off</span></span></td>
                                <td class="pb-1 pt-0 pl-5 text-end"></td>
                                <ul class="dropdown-menu stoplistDropdown">
                                    <li v-if="coupler.altName"><span v-if="coupler.isUnisonOff != 1">{{coupler.length}}' {{coupler.from}} to </span>{{coupler.to}}<span v-if="coupler.isUnisonOff == 1"> Unison Off</span></li>
                                    <li v-if="coupler.notes"><b>Notes</b>: {{coupler.notes}}</li>
                                </ul>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row justify-content-center" v-if="instrument.stoplists.length > 0 && instrument.stoplists[this.stoplistSelection].type == 0">
                <div class="col-12 col-md-6">
                    <p v-if="instrument.stoplists[this.stoplistSelection].description || instrument.stoplists[this.stoplistSelection].originalDate" class="mt-4 mb-0"><span v-if="instrument.stoplists[this.stoplistSelection].description">{{ instrument.stoplists[this.stoplistSelection].description }}</span><span v-if="instrument.stoplists[this.stoplistSelection].originalDate"><br v-if="instrument.stoplists[this.stoplistSelection].description"><b>Originally Written/Published:</b> {{ instrument.stoplists[this.stoplistSelection].originalDate }}</span></p>
                    <a v-bind:href="'/stoplists/' + instrument.stoplists[this.stoplistSelection].id" target="_blank" >Open In New Tab</a>
                </div>
            </div>
            <div class="row mb-5" v-if="instrument.stoplists.length > 0 && instrument.stoplists[this.stoplistSelection].type == 1">
                <a v-bind:href="'/stoplists/' + instrument.stoplists[this.stoplistSelection].id" target="_blank" class="text-md-end mt-5">Open In New Tab</a>
                <iframe v-bind:src="'/stoplists/' + instrument.stoplists[this.stoplistSelection].id" frameborder="0" class="w-100" style="width: 100% !important; min-height: 60vh; overflow: auto; white-space: nowrap;" v-if="stoplistIsText == true"></iframe>
                <iframe v-bind:src="apiEndpoint + '/uploads/stoplists/' + instrument.stoplists[this.stoplistSelection].filename" frameborder="0" class="w-100 mt-5" style="width: 100% !important; min-height: 60vh; overflow: auto; white-space: nowrap;" v-if="stoplistIsText == false"></iframe>
                <p v-if="instrument.stoplists[this.stoplistSelection].description || instrument.stoplists[this.stoplistSelection].originalDate" class="mt-2 mb-0"><span v-if="instrument.stoplists[this.stoplistSelection].description">{{ instrument.stoplists[this.stoplistSelection].description }}</span><span v-if="instrument.stoplists[this.stoplistSelection].originalDate"><br v-if="instrument.stoplists[this.stoplistSelection].description"><b>Originally Written/Published:</b> {{ instrument.stoplists[this.stoplistSelection].originalDate }}</span></p>
            </div>
            <div class="col-12 mb-5 mt-5" v-if="instrument.stoplists.length == 0">
                <h4>
                    No stoplist details are available. If you have stoplists, please consider sharing them with us.
                </h4>
            </div>
            <p class="mt-4 text-md-center editText">
                <i class="me-2">Something missing<span v-if="instrument.stoplists.length > 0"> or not quite correct</span>?</i>
                <a class="btn btn-sm btn-secondary me-2" :href="'/stoplists/add?instrumentIds='+instrument.id" target="_blank">Add Stoplist</a>
                <i class="me-2" v-if="!loggedIn || (loggedIn && instrument.stoplists.length > 0 && instrument.stoplists[stoplistSelection].type != 1)">or</i>
                <a class="btn btn-sm btn-secondary me-2" :href="editStoplistLink" target="_blank" v-if="!loggedIn || (loggedIn && instrument.stoplists.length > 0 && instrument.stoplists[stoplistSelection].type != 1)"><span v-if="!loggedIn">Suggest an Edit</span><span v-else>Edit Stoplist</span></a>
                <i v-if="loggedIn && instrument.stoplists.length > 0" class="me-2">or</i>
                <button class="btn btn-sm btn-danger me-2" v-if="loggedIn && instrument.stoplists.length > 0" @click="deleteStoplist(instrument.stoplists[stoplistSelection].id)">Delete</button>
                <span class="cR4" v-if="instrument.stoplists.length > 0 && instrument.stoplists[stoplistSelection].approvalStatus == 0"><i>Pending Review</i></span>
                <span class="cR4" v-if="instrument.stoplists.length > 0 && instrument.stoplists[stoplistSelection].approvalStatus == -1"><i>Denied In Review</i></span>
            </p>
        </div>
        <div class="container-fluid p-5 text-light bgG9" id="console">
            <div class="row align-items-center">
                <div class="col-12 col-md-8 mb-3 mb-md-0">
                    <h2 class="decorativeUnderline">CONSOLES</h2>
                </div>
                <div class="col-12 col-md-4 text-end" v-if="instrument.organConsoles.length > 0">
                    <div class="input-group">
                        <span class="input-group-text">Selected Item:</span>
                        <select class="form-select" v-model="consoleSelection" :disabled="instrument.organConsoles.length < 2">
                            <option v-for="(console, i) in instrument.organConsoles" v-bind:value="i" v-bind:key="console.id">
                                {{ console.name }}
                            </option>
                        </select>
                    </div>
                    <div class="form-text text-center text-secondary"><small>View additional console entries if they exist ☝️</small></div>
                </div>
            </div>
            <div class="container-fluid">
                <div class="row flex-nowrap overflow-auto mt-0 mt-lg-3" v-if="instrument.organConsoles.length > 0">
                    <div class="col-12 col-md-4 mt-3">
                        <hr />
                        <b>Builder</b>:
                        <span v-if="instrument.organConsoles[consoleSelection].builder">
                        <a :href="'/builders/' + instrument.organConsoles[consoleSelection].builder.id" class="text-light" style="text-underline-offset: 0.3em" target="_blank">
                            {{ instrument.organConsoles[consoleSelection].builder.name }}
                        </a>
                        </span><span v-else>Unknown</span>
                        <hr />
                        <b>Position</b>:
                        {{consolePositionOptions[instrument.organConsoles[consoleSelection].position]}}
                        <hr />
                        <b>Design</b>:
                        {{consoleTypeOptions[instrument.organConsoles[consoleSelection].type]}}
                        <hr />
                        <b>Manuals</b>: {{ instrument.organConsoles[consoleSelection].manuals }}
                        <hr />
                        <b>Stops/Registers</b>: {{ instrument.organConsoles[consoleSelection].stops || "Unknown"}}/{{
                        instrument.organConsoles[consoleSelection].registers || "Unknown"}}
                        <hr />
                        <b>Divisions</b>:
                        {{ instrument.organConsoles[consoleSelection].divisions }}
                        <hr />
                    </div>
                    <div class="col-12 col-md-4 d-inline-block mt-3">
                        <hr />
                        <b>Key Action</b>:
                        {{keyActionTypeOptions[instrument.organConsoles[consoleSelection].keyActionType]}}
                        <hr />
                        <b>Stop Action</b>:
                        {{stopActionTypeOptions[instrument.organConsoles[consoleSelection].stopActionType]}}
                        <hr />
                        <b>Stop Layout</b>:
                        {{stopLayoutTypeOptions[instrument.organConsoles[consoleSelection].stopLayoutType]}}
                        <hr />
                        <b>Manual Compass</b>:
                        {{ instrument.organConsoles[consoleSelection].manualCompass || "Unknown" }}
                        <hr />
                        <b>Pedal Compass</b>:
                        <span v-if="instrument.organConsoles[consoleSelection].pedalType != 8">{{ instrument.organConsoles[consoleSelection].pedalCompass || "Unknown" }}</span>
                        <span v-else>No Pedalboard</span>
                        <hr />
                        <b>Pedalboard Type</b>:
                        {{pedalTypeOptions[instrument.organConsoles[consoleSelection].pedalType]}}
                        <hr />
                    </div>
                    <div class="col-12 col-md-4 mt-3">
                        <hr />
                        <b>Expression Type</b>:
                        {{ expressionTypeOptions[instrument.organConsoles[consoleSelection].expressionType] }}
                        <hr />
                        <b>Has Crescendo</b>: {{ instrument.organConsoles[consoleSelection].hasCrescendo ? "Yes" : "No" }} <span v-if="console.crescendoIsRollschweller == 1">(Is Rollschweller)</span>
                        <hr />
                        <b>Crescendo Is Rollschweller</b>: {{ instrument.organConsoles[consoleSelection].crescendoIsRollschweller ? "Yes" : "No" }}
                        <hr />
                        <b>Has Sostenuto</b>: {{ instrument.organConsoles[consoleSelection].hasSostenuto ? "Yes" : "No" }}
                        <hr />
                        <b>Has Pedal Divide</b>: {{ instrument.organConsoles[consoleSelection].hasPedalDivide ? "Yes" : "No" }}
                        <hr />
                        <b>Has Transposer</b>: {{ instrument.organConsoles[consoleSelection].hasTransposer ? "Yes" : "No" }}
                        <hr />
                    </div>
                    <div class="col-12 col-md-4 d-inline-block mt-3">
                        <hr />
                        <b>Combination Action</b>:
                        {{combinationActionTypeOptions[instrument.organConsoles[consoleSelection].combinationActionType]}}
                        <hr />
                        <b>Control System</b>: {{ instrument.organConsoles[consoleSelection].combinationActionModel || "Unknown or N/A" }}
                        <hr />
                        <b>Has Sequencer</b>: {{ instrument.organConsoles[consoleSelection].hasSequencer ? "Yes" : "No" }}
                        <hr />
                        <b>Has Record/Playback</b>: {{ instrument.organConsoles[consoleSelection].hasRecordPlayback ? "Yes" : "No" }}
                        <hr />
                        <b>Has Wireless Control</b>: {{ instrument.organConsoles[consoleSelection].hasWirelesControl ? "Yes" : "No" }}
                        <hr />
                        <b>Has MIDI</b>: {{ instrument.organConsoles[consoleSelection].hasMIDI ? "Yes" : "No" }}
                        <hr />
                    </div>
                    <div class="col-12 col-md-4 d-inline-block mt-3">
                        <hr />
                        <b>Has Combination Thumb/Toe Pistons</b>: {{ instrument.organConsoles[consoleSelection].hasCombinationThumb ? "Yes" : "No" }} / {{ instrument.organConsoles[consoleSelection].hasCombinationToe ? "Yes" : "No" }}
                        <hr />
                        <b>Has Coupler Thumb/Toe Pistons</b>: {{ instrument.organConsoles[consoleSelection].hasCouplerThumb ? "Yes" : "No" }} / {{ instrument.organConsoles[consoleSelection].hasCouplerToe ? "Yes" : "No" }}
                        <hr />
                        <b>Has Sforzando Thumb/Toe Pistons</b>: {{ instrument.organConsoles[consoleSelection].hasSforzThumb ? "Yes" : "No" }} / {{ instrument.organConsoles[consoleSelection].hasSforzToe ? "Yes" : "No" }}
                        <hr />
                        <b>Has Combination Trundles</b>: {{ instrument.organConsoles[consoleSelection].hasCombinationTrundles ? "Yes" : "No" }}
                        <hr />
                        <b>Has Coupler Trundles</b>: {{ instrument.organConsoles[consoleSelection].hasCouplerTrundles ? "Yes" : "No" }}
                        <hr />
                        <b>Has Hitchdown Couplers</b>: {{ instrument.organConsoles[consoleSelection].hasHitchdownCouplers ? "Yes" : "No" }}
                        <hr />
                    </div>
                </div>
                <div class="text-md-center text-secondary mt-2" v-if="instrument.organConsoles.length > 0 && instrument.organConsoles[consoleSelection].notes && instrument.organConsoles[consoleSelection].notes != ''"><b>Additional Notes:</b> {{instrument.organConsoles[consoleSelection].notes}}</div>
            </div>
            <div class="col-12 mb-5 mt-5" v-if="instrument.organConsoles.length == 0">
                <h4 class="text-light">
                    No console details are available. If you have information, please consider sharing it with us.
                </h4>
            </div>
            <div class="text-md-center text-secondary mt-2" v-if="instrument.organConsoles.length > 0"><small>Scroll horizontally to view all details.</small></div>
            <p class="mt-3 text-md-center editText">
                <i class="me-2">Something missing<span v-if="instrument.organConsoles.length > 0"> or not quite correct</span>?</i>
                <a class="btn btn-sm btn-secondary me-2" :href="'/consoles/add?instrumentIds='+instrument.id" target="_blank">Add Console</a>
                <i v-if="instrument.organConsoles.length > 0" class="me-2">or</i>
                <a class="btn btn-sm btn-secondary me-2" v-if="instrument.organConsoles.length > 0" :href="editConsoleLink" target="_blank"><span v-if="!loggedIn">Suggest an Edit</span><span v-else>Edit Console</span></a>
                <i v-if="loggedIn && instrument.organConsoles.length > 0" class="me-2">or</i>
                <button class="btn btn-sm btn-danger me-2" v-if="loggedIn && instrument.organConsoles.length > 0" @click="deleteConsole(instrument.organConsoles[consoleSelection].id)">Delete</button>
                <span class="cR4" v-if="instrument.organConsoles.length > 0 && instrument.organConsoles[consoleSelection].approvalStatus == 0"><i>Pending Review</i></span>
                <span class="cR4" v-if="instrument.organConsoles.length > 0 && instrument.organConsoles[consoleSelection].approvalStatus == -1"><i>Denied In Review</i></span>
            </p>
        </div>
        <div class="container-fluid p-5" id="details" style="background-color: #f8f9fa;">
            <div class="row align-items-center">
                <div class="col-12 col-md-8 mb-3 mb-md-0">
                    <h2 style="text-decoration: underline; text-decoration-color: #ff8787; text-decoration-thickness: 0.3rem !important; text-underline-offset: 0.1em;">DETAILS</h2>
                </div>
                <div class="col-12 col-md-4 text-end">
                    <div class="btn-group" role="group">
                        <button type="button" class="btn" :class="{'btn-secondary': detailsDisplay == 0, 'btn-outline-secondary': detailsDisplay != 0}" @click="detailsDisplay=0">Notes</button>
                        <button type="button" class="btn" :class="{'btn-secondary': detailsDisplay == 1, 'btn-outline-secondary': detailsDisplay != 1}" @click="detailsDisplay=1">Documents ({{ instrument.documents.length }})</button>
                        <button type="button" class="btn" :class="{'btn-secondary': detailsDisplay == 2, 'btn-outline-secondary': detailsDisplay != 2}" @click="detailsDisplay=2">Blowers ({{ instrument.blowers.length }})</button>
                    </div>
                    <div class="form-text text-end"><small>Switch between notes, documents, and blowers ☝️</small></div>
                </div>
            </div>
            <div class="row mt-4" v-if="detailsDisplay == 0">
                <div class="col-12">
                    <h5 class="text-primary mb-3" v-if="instrument.conventionYears">Exhibited in the {{ instrument.conventionYears }} OHS convention(s)</h5>
                    <h5 class="mb-4" v-if="!instrument.futureInstrumentId && instrument.futureInstrumentId != ''">This instrument is: <b v-if="instrument.extant == 1" class="cR4">Extant</b> <b v-if="instrument.extant == 0" class="cR4">Not Extant</b> <b v-if="instrument.extant == 2" class="cR4">Unknown Status</b> <span class="text-secondary">and</span> <b v-if="instrument.playable == 1" class="cR4">Playable</b> <b v-if="instrument.playable == 0" class="cR4">Not Playable</b> <b v-if="instrument.playable == 2" class="cR4">Unknown Playability</b> <span class="text-secondary">in this location</span> <small class="text-secondary" v-if="instrument.biosHOL > 0">Marked BIOS {{ biosHOLTypeOptions[instrument.biosHOL] }}</small></h5>
                    <div class="accordion" id="accordionExample" v-if="instrument.notes.length > 0">
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="headingOne">
                                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    View Notes
                                </button>
                            </h2>
                            <div id="collapseOne" class="accordion-collapse" aria-labelledby="headingOne"
                                data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <div v-for="(note, index) in instrument.notes" v-bind:key="note.id" style="white-space: pre-wrap;">
                                        <hr v-if="index > 0">
                                        <i class="text-secondary">{{ note.createdName }} on {{getNoteDate(note)}}: </i>
                                        <small v-if="loggedIn">(<a :href="'/notes/'+note.id+'/edit'" target="_blank" class="cR4 text-decoration-none">Edit</a>/<a href="#details" @click="deleteNote(note.id)" class="cR4 text-decoration-none">Delete</a>) <span class="cR4" v-if="note.approvalStatus == 0"><i>Pending Review</i></span><span class="cR4" v-if="note.approvalStatus == -1"><i>Denied In Review</i></span></small>
                                        <br>{{note.content}}
                                    </div>
                                    <p v-if="instrument.notes.length == 0" class="mb-0">
                                        No notes have been written. If you have information, please consider sharing it with us.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="accordion mt-3" id="recordingAccordion" v-if="recordingWebpages.length > 0">
                        <div class="accordion-item">
                            <h2 class="accordion-header" id="recordingHeadingOne">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#recordingCollapseOne" aria-expanded="false" aria-controls="recordingCollapseOne">
                                    View Recordings
                                </button>
                            </h2>
                            <div id="recordingCollapseOne" class="accordion-collapse collapse" aria-labelledby="recordingHeadingOne"
                                data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <ul class="mb-0">
                                        <div v-for="(webpage) in recordingWebpages" v-bind:key="webpage.id">
                                            <li>
                                                <a :href="webpage.url" target="_blank" class="text-decoration-none" data-bs-toggle="tooltip" v-bind:data-bs-title="webpage.description">{{webpage.name}}</a> <small v-if="loggedIn">(<a :href="'/webpages/'+webpage.id+'/edit'" target="_blank" class="cR4 text-decoration-none">Edit</a>/<a href="#details" @click="deleteWebpage(webpage.id)" class="cR4 text-decoration-none">Delete</a>) <span class="cR4" v-if="webpage.approvalStatus == 0"><i>Pending Review</i></span><span class="cR4" v-if="webpage.approvalStatus == -1"><i>Denied In Review</i></span></small>
                                                <span v-if="webpage.description" class="d-block">{{ webpage.description }}</span>
                                            </li>
                                        </div>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p class="mt-4" v-if="webpageWebpages.length > 0"><b>Webpage Links</b>: <span v-for="(webpage, index) in webpageWebpages" v-bind:key="webpage.id"><span
                                v-if="index > 0">, </span><a :href="webpage.url" target="_blank"
                                class="text-decoration-none" data-bs-toggle="tooltip" v-bind:data-bs-title="webpage.description">{{webpage.name}}</a> <small v-if="loggedIn">(<a :href="'/webpages/'+webpage.id+'/edit'" target="_blank" class="text-success text-decoration-none">Edit</a>/<a href="#details" @click="deleteWebpage(webpage.id)" class="cR4 text-decoration-none">Delete</a>) <span class="cR4" v-if="webpage.approvalStatus == 0"><i>Pending Review</i></span><span class="cR4" v-if="webpage.approvalStatus == -1"><i>Denied In Review</i></span></small></span></p>
                    <p class="mt-2" v-if="instrument.references.length > 0"><b>Related Instrument Entries</b>: <span
                            v-for="(item, index) in instrument.references" v-bind:key="item.id"><span v-if="index > 0">,
                            </span><a :href="'/instruments/'+item.referencedInstrumentId" target="_blank"
                                class="text-decoration-none" v-if="item.referencedInstrumentId && item.referencedInstrument && item.referencedInstrument.builder">{{item.referencedInstrument.builder.name}} <span
                                        v-if="item.referencedInstrument.opus || item.referencedInstrument.year">(</span><span
                                        v-if="item.referencedInstrument.opus">Opus <span v-if="item.referencedInstrument.opusPrefix">{{ item.referencedInstrument.opusPrefix }}</span>{{ item.referencedInstrument.opus}}<span v-if="item.referencedInstrument.opusSuffix">{{ item.referencedInstrument.opusSuffix }}</span><span v-if="item.referencedInstrument.year">,
                                        </span></span><span v-if="item.referencedInstrument.year"><span v-if="item.referencedInstrument.yearPrefix">{{ item.referencedInstrument.yearPrefix }}</span>{{ item.referencedInstrument.year }}<span v-if="item.referencedInstrument.yearSuffix">{{ item.referencedInstrument.yearSuffix }}</span></span><span
                                        v-if="item.referencedInstrument.opus || item.referencedInstrument.year">)</span></a> <small v-if="loggedIn">(<span v-if="item.approvalStatus == 0"><a href="#details" @click="approveReference(item.id)" class="cR4 text-decoration-none">Approve</a>/</span><a href="#details" @click="deleteReference(item.id)" class="cR4 text-decoration-none">Delete</a>) <span class="cR4" v-if="item.approvalStatus == 0"><i>Pending Review</i></span><span class="cR4" v-if="item.approvalStatus == -1"><i>Denied In Review</i></span></small></span></p>
                </div>
                <p class="mt-5 editText">
                    <i class="me-2">Something missing or not quite correct?</i>
                    <a class="btn btn-sm btn-secondary me-2" :href="'/notes/add?instrumentIds='+instrument.id" target="_blank">Add Note</a>
                    <i class="me-2">or</i> 
                    <a class="btn btn-sm btn-secondary me-2" :href="'/webpages/add?instrumentIds='+instrument.id" target="_blank">Add Webpage</a>
                    <i class="me-2">or</i>
                    <a class="btn btn-sm btn-secondary me-2" :href="'/references/add?instrumentId='+instrument.id" target="_blank">Add Cross Reference</a>
                    <i class="me-2">or</i>
                    <a class="btn btn-sm btn-secondary me-2" :href="editInstrumentLink" target="_blank"><span v-if="!loggedIn">Suggest an Edit</span><span v-else>Edit Instrument Details</span></a>
                </p>
            </div>
            <div class="justify-content-center" v-if="detailsDisplay == 1">
                <div class="row">
                    <div class="col-12 mt-5" v-for="document in instrument.documents" v-bind:key="document.id">
                        <p class="text-md-end mb-0"><a v-bind:href="apiEndpoint + '/uploads/documents/' + document.filename" target="_blank">Open In New Tab</a></p>
                        <iframe v-bind:src="apiEndpoint + '/uploads/documents/' + document.filename" style="width: 100% !important; min-height: 60vh;"></iframe>
                        <p v-if="document.description || document.originalDate"><b>Description:</b> {{document.description}} <span v-if="document.originalDate"><br v-if="document.description"><b>Originally Written/Published:</b> {{ document.originalDate }}</span></p>
                        <div v-if="loggedIn">
                            <a :href="'/documents/' + document.id + '/edit'" class="btn btn-sm btn-secondary me-1" target="_blank">Edit</a><button class="btn btn-sm btn-danger me-2" @click="deleteDocument(document.id)">Delete</button><span class="cR4" v-if="document.approvalStatus == 0"><i>Pending Review</i></span><span class="cR4" v-if="document.approvalStatus == -1"><i>Denied In Review</i></span>
                        </div>
                    </div>
                    <div class="col-12 mt-5" v-if="instrument.documents.length == 0">
                        <h4>
                            No documents are available. If you have any, please consider sharing them with us.
                        </h4>
                    </div>
                </div>
                <p class="mt-5 editText text-md-center">
                    <i class="me-2">Something missing<span v-if="instrument.documents.length > 0"> or not quite correct</span>?</i>
                    <a class="btn btn-sm btn-secondary me-2" :href="'/documents/add?instrumentIds='+instrument.id" target="_blank">Add Document</a>
                    <i v-if="instrument.documents.length > 0 && !loggedIn" class="me-2">or</i>
                    <a class="btn btn-sm btn-secondary me-2" v-if="instrument.documents.length > 0 && !loggedIn" :href="'/editRequests/add?itemCategory=2&itemType=2&itemId='+instrument.id" target="_blank">Suggest an Edit</a>
                </p>
            </div>
            <div class="mt-5" v-if="detailsDisplay == 2">
                <div v-if="instrument.blowers.length > 0">
                    <div class="row justify-content-center mb-2" v-for="(blower, index) in instrument.blowers" v-bind:key="blower.id">
                        <div class="col-12 col-md-4 mb-3 mb-md-0" v-if="blower.builder || blower.pressure || blower.numFans || blower.fanSize">
                            <h4>Blower -</h4>
                            <div v-if="blower.builder"><b class="text-secondary">Built by:</b> <a :href="'/builders/'+blower.builder.id" target="_blank">{{blower.builder.name}}</a></div>
                            <div v-if="blower.pressure"><b class="text-secondary">Output Pressure:</b> {{blower.pressure}}"</div>
                            <div v-if="blower.numFans || blower.fanSize">
                                <b class="text-secondary">Fans:</b> {{blower.numFans}} <span v-if="blower.numFans && blower.fanSize">X</span> <span v-if="blower.fanSize">{{blower.fanSize}}"</span>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 mb-3 mb-md-0" v-if="blower.motorBuilder || blower.motorRPM || blower.motorHP">
                            <h4>Motor -</h4>
                            <div v-if="blower.motorBuilder"><b class="text-secondary">Built by:</b> <a :href="'/builders/'+blower.motorBuilder.id" target="_blank">{{blower.motorBuilder.name}}</a></div>
                            <div v-if="blower.motorHP"><b class="text-secondary">Model:</b> {{blower.motorHP}} HP</div>
                            <div v-if="blower.motorRPM"><b class="text-secondary">Speed:</b> {{blower.motorRPM}} RPM</div>
                        </div>
                        <div class="col-12 col-md-3 mb-3 mb-md-0" v-if="blower.motorSerial || blower.serial">
                            <h4>Specifics -</h4>
                            <div v-if="blower.name"><b class="text-secondary">Used For:</b> {{blower.name}}</div>
                            <div v-if="blower.motorSerial"><b class="text-secondary">Motor Serial #:</b> {{blower.motorSerial}}</div>
                            <div v-if="blower.serial"><b class="text-secondary">Blower Serial #:</b> {{blower.serial}}</div>
                        </div>
                        <div v-if="loggedIn" class="col-12 col-md-3 mt-3">
                            <a :href="'/blowers/' + blower.id + '/edit'" class="btn btn-sm btn-secondary me-1" target="_blank">Edit</a><button class="btn btn-sm btn-danger me-2" @click="deleteBlower(blower.id)">Delete</button><span class="cR4" v-if="blower.approvalStatus == 0"><i>Pending Review</i></span><span class="cR4" v-if="blower.approvalStatus == -1"><i>Denied In Review</i></span>
                        </div>
                        <hr class="mt-4" v-if="index != instrument.blowers.length - 1">
                    </div>
                </div>
                <div class="col-12" v-if="instrument.blowers.length == 0">
                    <h4>
                        No blower details are available. If you have information, please consider sharing it with us.
                    </h4>
                </div>
                <p class="mt-5 editText text-md-center">
                    <i class="me-2">Something missing<span v-if="instrument.blowers.length > 0"> or not quite correct</span>?</i>
                    <a class="btn btn-sm btn-secondary me-2" :href="'/blowers/add?instrumentIds='+instrument.id" target="_blank">Add Blower</a>
                    <i v-if="instrument.blowers.length > 0 && !loggedIn" class="me-2">or</i>
                    <a class="btn btn-sm btn-secondary me-2" v-if="instrument.blowers.length > 0 && !loggedIn" :href="'/editRequests/add?itemCategory=2&itemType=7&itemId='+instrument.id" target="_blank">Suggest an Edit</a>
                </p>
            </div>
        </div>
        <div class="mapParent">
            <!--<GoogleMap api-key="AIzaSyAOj5YVPBDW02gtH3_LT0niJexM2Ci1o2M" style="width: 100%; height: 30rem;" :center="{ lat: instrument.location.latitude, lng: instrument.location.longitude }" :zoom="14" v-if="instrument.location && instrument.location.latitude && instrument.location.longitude" :zoomControl="false" :fullscreenControl="false" :streetViewControl="false" :mapTypeControl="false">
                <MarkerIcon :options="{ position: { lat: instrument.location.latitude, lng: instrument.location.longitude } }"></MarkerIcon>
            </GoogleMap>-->
            <iframe allowfullscreen frameborder="0" :src="'https://www.google.com/maps/embed/v1/place?key=AIzaSyAOj5YVPBDW02gtH3_LT0niJexM2Ci1o2M&amp;q='+googleAddress+'&amp;zoom=14'" style="width: 100%;height: 30rem;"></iframe>
        </div>
    </div>
    <div v-if="loading == true" class="mt-5 text-center">
        <h1 class="d-inline-block text-secondary me-3">Loading...</h1>
        <div class="spinner-border text-secondary d-inline-block" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</template>

<script>
    import InstrumentService from "../services/instrument.service";
    import ImageService from "../services/image.service";
    import ConsoleService from "../services/console.service";
    import WebpageService from "../services/webpage.service";
    import ReferenceService from "../services/reference.service";
    import NoteService from "../services/note.service";
    import BlowerService from "../services/blower.service";
    import DocumentService from "../services/document.service";
    import StoplistService from "../services/stoplist.service";
    import moment from "moment";
    import ItemTypes from "../itemTypes";
    import MasonryWall from '@yeger/vue-masonry-wall'
    //import { GoogleMap, Marker as MarkerIcon } from "vue3-google-map";

    export default {
        components: {
            MasonryWall
        },
        name: "Instrument",
        metaInfo() {
            return {
                title: this.metaTitle ? this.metaTitle + ' | Pipe Organ Database' : 'Instrument Details | Pipe Organ Database',
                meta: [
                    {
                        property: 'og:type',
                        name: 'og:type',
                        content: 'website'
                    },
                    {
                        property: 'og:title',
                        name: 'og:title',
                        content: this.metaTitle ? this.metaTitle + ' | Pipe Organ Database' : 'Instrument Details | Pipe Organ Database'
                    },
                    {
                        property: 'og:description',
                        name: 'og:description',
                        content: this.metaDescription ? this.metaDescription : 'Instrument Details',
                    },
                    {
                        property: 'og:image',
                        name: 'og:image',
                        content: this.headerImage ? this.apiEndpoint + '/uploads/images/' + this.headerImage.fullThumbFilename : 'https://api.pipeorgandatabase.org/uploads/images/blank.png'
                    },
                    {
                        property: 'twitter:card',
                        name: 'twitter:card',
                        content: 'summary_large_image'
                    },
                    {
                        property: 'twitter:title',
                        name: 'twitter:title',
                        content: this.metaTitle ? this.metaTitle + ' | Pipe Organ Database' : 'Instrument Details | Pipe Organ Database'
                    },
                    {
                        property: 'twitter:description',
                        name: 'twitter:description',
                        content: this.metaDescription ? this.metaDescription : 'Instrument Details',
                    },
                    {
                        property: 'twitter:image',
                        name: 'twitter:image',
                        content: this.headerImage ? this.apiEndpoint + '/uploads/images/' + this.headerImage.fullThumbFilename : 'https://api.pipeorgandatabase.org/uploads/images/blank.png'
                    }
                ]
            }
        },
        created: function () {
            this.moment = moment;
        },
        computed: {
            loggedIn() {
                return this.$store.state.auth.status.loggedIn;
            },
            apiEndpoint() {
                return process.env.VUE_APP_API_ENDPOINT;
            },
            currentUser() {
                return this.$store.state.auth.user;
            },
            filteredImages() {
                let filtered = this.instrument.images.filter((item) => {
                    if (this.imageType == -1) {
                        return true;
                    }
                    return (item.type == this.imageType);
                }).sort((a, b) => {
                    let imageTypesOrder = [2, 7, 3, 4, 5, 6, 8, 9, 1, 0];

                    // First, sort by isPanoramic (non-panoramic first)
                    if (a.isPanoramic == 1 && b.isPanoramic != 1) {
                        return 1;
                    } else if (a.isPanoramic != 1 && b.isPanoramic == 1) {
                        return -1;
                    }

                    // Then, sort by type using the order defined in imageTypesOrder
                    const indexA = imageTypesOrder.indexOf(a.type);
                    const indexB = imageTypesOrder.indexOf(b.type);
                    
                    if (indexA < indexB) {
                        return -1;
                    } else if (indexA > indexB) {
                        return 1;
                    }

                    // Lastly, sort by created
                    if (a.createdAt > b.createdAt) {
                        return 1;
                    } else if (a.createdAt < b.createdAt) {
                        return -1;
                    }
                    
                    return 0;
                });
                
                if (filtered.length > 10 && this.showAllImages == 0 && this.imageType == -1) {
                    return filtered.slice(0, 10);
                }

                return filtered;
            },
            webpageWebpages() {
                return this.instrument.webpages.filter((item) => {
                    return item.siteType == 0;
                });
            },
            recordingWebpages() {
                return this.instrument.webpages.filter((item) => {
                    return item.siteType == 1;
                });
            },
            googleAddress() {
                if (this.instrument.location) {
                    var uri = encodeURI((this.instrument.location.address || "") + " " + (this.instrument.location.city || "") + " " + (this.instrument.location.neighborhood || "") + " " + (this.instrument.location.state || "") + " " + this.instrument.location.country);
                    return uri;
                } else {
                    return encodeURI(this.instrument.submissionLocation);
                }
            },
            youtubeAddress() {
                if (this.instrument.location) {
                    return encodeURI(this.instrument.location.name + " " + (this.instrument.location.city || "") + " pipe organ");
                } else {
                    return encodeURI(this.instrument.submissionLocation + " pipe organ");
                }
            },
            editInstrumentLink() {
                if (this.loggedIn) {
                    return '/instruments/'+this.instrument.id+'/edit';
                }
                return '/editRequests/add?itemCategory=2&itemType=0&itemId='+this.instrument.id;
            },
            editConsoleLink() {
                if (this.loggedIn) {
                    return '/consoles/'+this.instrument.organConsoles[this.consoleSelection].id+'/edit';
                }
                return '/editRequests/add?itemCategory=2&itemType=6&itemId='+this.instrument.id;
            },
            editStoplistLink() {
                if (this.loggedIn && this.instrument.stoplists[this.stoplistSelection].type == 0) {
                    return '/stoplists/'+this.instrument.stoplists[this.stoplistSelection].id+'/edit';
                } else if (this.loggedIn && this.instrument.stoplists[this.stoplistSelection].type == 1) {
                    return '/stoplists/add?instrumentIds='+this.instrument.id;
                }
                return '/editRequests/add?itemCategory=2&itemType=5&itemId='+this.instrument.id;
            }
        },
        data() {
            return {
                keyActionTypeOptions: ItemTypes.keyActionTypes,
                stopActionTypeOptions: ItemTypes.stopActionTypes,
                stopLayoutTypeOptions: ItemTypes.stopLayoutTypes,
                pedalTypeOptions: ItemTypes.pedalTypes,
                combinationActionTypeOptions: ItemTypes.combinationActionTypes,
                consoleTypeOptions: ItemTypes.consoleTypes,
                imageTypeOptions: ItemTypes.imageTypes,
                divisionPositionTypeOptions: ItemTypes.divisionPositionTypes,
                divisionChestActionTypeOptions: ItemTypes.divisionChestActionTypes,
                divisionStopActionTypeOptions: ItemTypes.divisionStopActionTypes,
                consolePositionOptions: ItemTypes.consolePositions,
                expressionTypeOptions: ItemTypes.expressionTypes,
                biosHOLTypeOptions: ItemTypes.biosHOLTypes,
                loading: true,
                instrument: null,
                imageType: -1,
                imageTypes: [],
                headerImage: null,
                consoleSelection: 0,
                stoplistSelection: 0,
                stoplistIsText: false,
                detailsDisplay: 0,
                stoplistDivisions: {},
                showAllImages: 0,
                tooltips: [],
                metaTitle: null,
                metaDescription: null,
                sponsor: null
            };
        },
        mounted() {
            this.loadInitial(this.$route.params.id);
        },
        methods: {
            loadInitial(id) {
                InstrumentService.get(id).then(
                    (response) => {
                        this.instrument = response.data;

                        this.metaTitle = "";
                        if (this.instrument.builder) {
                            this.metaTitle += this.instrument.builder.name;
                        } else {
                            this.metaTitle += this.instrument.submissionBuilder;
                        }
                        if (this.instrument.opus) {
                            this.metaTitle += " - Opus " + this.instrument.opus;
                            if (this.instrument.year) {
                                this.metaTitle += ",";
                            }
                        }
                        if (this.instrument.year) {
                            this.metaTitle += " " + this.instrument.year;
                        }
                        var locationName;
                        if (this.instrument.location) {
                            locationName = this.instrument.location.name ? this.instrument.location.name : "Unidentified Location";
                            this.metaTitle += " | " + locationName;
                            if (this.instrument.location.city || this.instrument.location.state || this.instrument.location.country || this.instrument.location.neighborhood) {
                                this.metaTitle += " -";
                            }
                            if (this.instrument.location.city && this.instrument.location.city != "") {
                                this.metaTitle += " " + this.instrument.location.city;
                                if (this.instrument.location.neighborhood && this.instrument.location.neighborhood != "") {
                                    this.metaTitle += " (" + this.instrument.location.neighborhood + "), ";
                                } else {
                                    this.metaTitle += ", ";
                                }
                            } else if (this.instrument.location.neighborhood && this.instrument.location.neighborhood != "") {
                                this.metaTitle += " " + this.instrument.location.neighborhood + ", ";
                            }
                            if (this.instrument.location.state) {
                                this.metaTitle += " " + this.instrument.location.state + ", ";
                            }
                            if (this.instrument.location.country && this.instrument.location.country != "") {
                                this.metaTitle += this.instrument.location.country;
                            }
                        } else {
                            locationName = this.instrument.submissionLocation;
                            this.metaTitle += " | " + locationName;
                        }
                        this.metaTitle = this.metaTitle.replace(/ ,/g, ',').trim();

                        this.metaDescription = "";
                        if(this.instrument.ranks) {
                            this.metaDescription += this.instrument.ranks + " Ranks";
                        }
                        if(this.instrument.pipes) {
                            this.metaDescription += this.metaDescription ? " - " : "";  // Adds a hyphen only if this.metaDescription is not empty
                            this.metaDescription += this.instrument.pipes.toLocaleString() + " Pipes";
                        }
                        if(this.instrument.divisions) {
                            this.metaDescription += this.metaDescription ? " - " : "";  // Adds a hyphen only if this.metaDescription is not empty
                            this.metaDescription += this.instrument.divisions + " Physical Divisions";
                        }
                        if (this.metaDescription == "") {
                            this.metaDescription = null;
                        }

                        this.imageTypes = [];
                        var headerImages = [];
                        this.instrument.images.forEach((element) => {
                            if (element.isHeader == 1) {
                                headerImages.push(element);
                            }
                            if (this.imageTypes.indexOf(element.type) == -1) {
                                this.imageTypes.push(element.type);
                            }
                        });
                        this.headerImage = headerImages[Math.floor(Math.random() * headerImages.length)];
                        if (!this.headerImage || this.headerImage == null) {
                            this.headerImage = { filename: "blank.png", fullThumbFilename: "blank.png" };
                        }
                        this.calculateStoplist();

                        // Calculate sponsor display
                        if (this.instrument.location) {
                            if (this.instrument.location.state == "MA") {
                                this.sponsor = {
                                    state: "Massachusetts",
                                    webpage: "https://www.czelusniakdugal.com/",
                                    image: "sponsor02.jpg"
                                }
                            } else if (this.instrument.location.state == "CT") {
                                this.sponsor = {
                                    state: "Connecticut",
                                    webpage: "http://www.slhorgans.com/welcome.html",
                                    image: "sponsor03.jpg"
                                }
                            } else if (this.instrument.location.state == "NY") {
                                this.sponsor = {
                                    state: "New York",
                                    webpage: "https://foleybaker.com/",
                                    image: "sponsor01.jpg"
                                }
                            } else if (this.instrument.location.state == "GA") {
                                this.sponsor = {
                                    state: "Georgia",
                                    webpage: "https://www.parkeyorgans.com/",
                                    image: "sponsor06.jpg"
                                }
                            } else if (this.instrument.location.state == "TN") {
                                this.sponsor = {
                                    state: "Tennessee",
                                    webpage: "https://www.milnarorgan.com/",
                                    image: "sponsor07.jpg"
                                }
                            } else if (this.instrument.location.state == "PA") {
                                this.sponsor = {
                                    state: "Pennsylvania",
                                    webpage: "https://www.columbiaorgan.com/",
                                    image: "sponsor05.jpg"
                                }
                            } else if (this.instrument.location.state == "OH") {
                                this.sponsor = {
                                    state: "Ohio",
                                    webpage: "https://www.schantzorgan.com/",
                                    image: "sponsor08.jpg"
                                }
                            } else if (this.instrument.location.state == "IL") {
                                this.sponsor = {
                                    state: "Illinois",
                                    webpage: "https://buzardorgans.com/",
                                    image: "sponsor09.jpg"
                                }
                            }
                        }

                        this.loading = false;
                    },
                    (error) => {
                        console.log(error);
                        if (error.response && error.response.status) {
                            this.$router.push("/" + error.response.status);
                        }
                    }
                );
            },
            getImageDate(image) {
                if (image.dateTaken) {
                    return " on " + moment(image.dateTaken).format("MM/DD/YYYY");
                } else if (image.dateTakenApprox) {
                    return " approx. " + image.dateTakenApprox;
                }
                return "";
            },
            getDate(date) {
                if (date) {
                    return moment(date).format("MMMM Do, YYYY");
                }
                return "";
            },
            getNoteDate(note) {
                return moment(note.createdAt).format("MMMM Do, YYYY");
            },
            toRoman(num) {
                let lookup = {M:1000,CM:900,D:500,CD:400,C:100,XC:90,L:50,XL:40,X:10,IX:9,V:5,IV:4,I:1};
                let roman = '';
                for ( let i in lookup ) {
                    while ( num >= lookup[i] ) {
                    roman += i;
                    num -= lookup[i];
                    }
                }
                return roman;
            },
            calculateStoplist() {
                if (this.instrument.stoplists.length > 0) {
                    var selectedList = this.instrument.stoplists[this.stoplistSelection];
                    if (selectedList.type == 0) {
                        StoplistService.get(selectedList.id).then(
                            (response) => {
                                selectedList = response.data;
                                this.stoplistDivisions = {};

                                selectedList.divisions.sort((a, b) => a.order - b.order).forEach(division => {
                                    this.stoplistDivisions[division.name] = division;
                                    this.stoplistDivisions[division.name].stops = [];
                                    this.stoplistDivisions[division.name].couplers = [];
                                });

                                selectedList.stops.sort((a, b) => a.order - b.order).forEach(stopItem => {
                                    if (stopItem.from !== null) {
                                        if (stopItem.to in this.stoplistDivisions) {
                                            this.stoplistDivisions[stopItem.to].couplers.push(stopItem);
                                        }
                                    } else {
                                        if (stopItem.division in this.stoplistDivisions) {
                                            this.stoplistDivisions[stopItem.division].stops.push(stopItem);
                                        }
                                    }
                                });

                                // After pushing the stops and couplers, sort them in order
                                Object.values(this.stoplistDivisions).forEach(division => {
                                    division.stops.sort((a, b) => a.order - b.order);
                                    division.couplers.sort((a, b) => a.order - b.order);
                                });
                            },
                            (error) => {
                                console.log(error);
                                this.stoplistDivisions = {};
                            }
                        );
                    } else {
                        this.stoplistDivisions = {};
                        if (selectedList.filename && selectedList.filename.endsWith('.txt')) {
                            this.stoplistIsText = true;
                        } else {
                            this.stoplistIsText = false;
                        }
                    }
                } else {
                    this.stoplistDivisions = {};
                }
            },
            deleteInstrument() {
                if (confirm("Are you sure you want to delete this instrument?")) {
                    InstrumentService.delete(this.instrument.id).then(
                        () => {
                            this.$router.push("/instruments");
                        },
                        (error) => {
                            console.log(error);
                            if (error.response && error.response.status) {
                                this.$router.push("/" + error.response.status);
                            }
                        }
                    );
                }
            },
            deleteImage(imageId) {
                if (confirm("Are you sure you want to delete this image?")) {
                    ImageService.delete(imageId).then(
                        () => {
                            this.loadInitial(this.instrument.id);
                        },
                        (error) => {
                            console.log(error);
                            if (error.response && error.response.status) {
                                this.$router.push("/" + error.response.status);
                            }
                        }
                    );
                }
            },
            deleteStoplist(stoplistId) {
                if (confirm("Are you sure you want to delete this stoplist?")) {
                    StoplistService.delete(stoplistId).then(
                        () => {
                            this.loadInitial(this.instrument.id);
                            this.calculateStoplist();
                        },
                        (error) => {
                            console.log(error);
                            if (error.response && error.response.status) {
                                this.$router.push("/" + error.response.status);
                            }
                        }
                    );
                }
            },
            deleteConsole(consoleId) {
                if (confirm("Are you sure you want to delete this console?")) {
                    ConsoleService.delete(consoleId).then(
                        () => {
                            this.loadInitial(this.instrument.id);
                        },
                        (error) => {
                            console.log(error);
                            if (error.response && error.response.status) {
                                this.$router.push("/" + error.response.status);
                            }
                        }
                    );
                }
            },
            deleteNote(noteId) {
                if (confirm("Are you sure you want to delete this note?")) {
                    NoteService.delete(noteId).then(
                        () => {
                            this.loadInitial(this.instrument.id);
                        },
                        (error) => {
                            console.log(error);
                            if (error.response && error.response.status) {
                                this.$router.push("/" + error.response.status);
                            }
                        }
                    );
                }
            },
            deleteWebpage(webpageId) {
                if (confirm("Are you sure you want to delete this webpage?")) {
                    WebpageService.delete(webpageId).then(
                        () => {
                            this.loadInitial(this.instrument.id);
                        },
                        (error) => {
                            console.log(error);
                            if (error.response && error.response.status) {
                                this.$router.push("/" + error.response.status);
                            }
                        }
                    );
                }
            },
            deleteReference(referenceId) {
                if (confirm("Are you sure you want to delete this reference?")) {
                    ReferenceService.delete(referenceId).then(
                        () => {
                            this.loadInitial(this.instrument.id);
                        },
                        (error) => {
                            console.log(error);
                            if (error.response && error.response.status) {
                                this.$router.push("/" + error.response.status);
                            }
                        }
                    );
                }
            },
            approveReference(referenceId) {
                if (confirm("Are you sure you want to approve this reference?")) {
                    ReferenceService.patch(referenceId).then(
                        () => {
                            this.loadInitial(this.instrument.id);
                        },
                        (error) => {
                            console.log(error);
                            if (error.response && error.response.status) {
                                this.$router.push("/" + error.response.status);
                            }
                        }
                    );
                }
            },
            deleteDocument(documentId) {
                if (confirm("Are you sure you want to delete this document?")) {
                    DocumentService.delete(documentId).then(
                        () => {
                            this.loadInitial(this.instrument.id);
                        },
                        (error) => {
                            console.log(error);
                            if (error.response && error.response.status) {
                                this.$router.push("/" + error.response.status);
                            }
                        }
                    );
                }
            },
            deleteBlower(blowerId) {
                if (confirm("Are you sure you want to delete this blower?")) {
                    BlowerService.delete(blowerId).then(
                        () => {
                            this.loadInitial(this.instrument.id);
                        },
                        (error) => {
                            console.log(error);
                            if (error.response && error.response.status) {
                                this.$router.push("/" + error.response.status);
                            }
                        }
                    );
                }
            }
        },
    };
</script>
